
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
data () {
return {
showScrollBox: false,
list: [],
unreadList: [],
displayList: [],
isShowLoadMore: false,
loadMoreTip: '点击加载更多',
pageNum: 1, // 第几页参数
pageSize: 10, // 每次加载显示个数
isHasNextPage: true, // 是否存在下一页更多数据
iconCircle: 'icon-circle',
orangeIconCircle: ['icon-circle', 'message-center-orange'],
clickedCaseId: '',
sender: '',
general: '',
patName: '',
btnValue: '',
cannotClickBtn: false
}
},
components: { Swipeout, SwipeoutItem, SwipeoutButton, XDialog, Group, XSwitch, LoadMore, XButton },
beforeMount () {
this.$vue = this
this.getNewsList()
},
methods: {

async markAllDel () {

this.displayList = []

this.unreadList = []
let suc = await this.$http.post(this.$vue.getData('MARK_ALL_DEL'))
if (suc.data.result === '1') {
let params = new URLSearchParams()
params.append('pageSize', this.pageSize.toString())
params.append('pageNum', this.pageNum.toString())
try {
let success = await this.$http.post(this.$vue.getData('LIST_NEWS_BY_USERID'), params)
let mydata = success.data.data

this.listNum = mydata.total

this.list = mydata.list

this.isHasNextPage = mydata.hasNextPage
this.isShowLoadMore = false
if (this.isHasNextPage) {
this.loadMoreTip = '点击加载更多'
} else {
this.loadMoreTip = '没有更多数据了'
}
} catch (e) {
console.log(e)
}
}
},

async markAllAsRead () {

this.unreadList = []
let suc = await this.$http.post(this.$vue.getData('MARK_ALL_AS_READ'))
if (suc.data.result === '1') {

let params = new URLSearchParams()
params.append('pageSize', this.pageSize.toString())
params.append('pageNum', this.pageNum.toString())
try {
let success = await this.$http.post(this.$vue.getData('LIST_NEWS_BY_USERID'), params)
let mydata = success.data.data

this.listNum = mydata.total

this.list = mydata.list

this.displayList = []

for (let i = 0; i < this.list.length; i++) {
this.displayList.push(this.list[i].ID)
}

this.isHasNextPage = mydata.hasNextPage
this.isShowLoadMore = false
if (this.isHasNextPage) {
this.loadMoreTip = '点击加载更多'
} else {
this.loadMoreTip = '没有更多数据了'
}
} catch (e) {
console.log(e)
}
}
},

async getNewsList () {
let params = new URLSearchParams()
params.append('pageSize', this.pageSize.toString())
params.append('pageNum', this.pageNum.toString())
try {
let success = await this.$http.post(this.$vue.getData('LIST_NEWS_BY_USERID'), params)
let mydata = success.data.data

this.listNum = mydata.total

this.list = this.list.concat(mydata.list)

this.unreadList = []

this.displayList = []

for (let i = 0; i < this.list.length; i++) {

if (this.list[i].STATE === 0) {
this.unreadList.push(this.list[i].ID)
}
this.displayList.push(this.list[i].ID)
}

this.isHasNextPage = mydata.hasNextPage
this.isShowLoadMore = false
if (this.isHasNextPage) {
this.loadMoreTip = '点击加载更多'
} else {
this.loadMoreTip = '没有更多数据了'
}
} catch (e) {
console.log(e)
}
},

loadMore () {

if (this.isHasNextPage) {
this.isShowLoadMore = true
this.loadMoreTip = '正在加载中'
this.pageNum = this.pageNum + 1
this.getNewsList()
}
},

async markAsRead (row) {
let params = new URLSearchParams()
params.append('id', row.ID)
let index = this.unreadList.indexOf(row.ID)
if (index !== -1) {

let suc = await this.$http.post(this.$vue.getData('MARK_AS_READ'), params)
if (suc.data.result === '1') {

let index = this.unreadList.indexOf(row.ID)
this.unreadList.splice(index, 1)
}
}

event.stopPropagation()
},

clickOn (row) {
this.showScrollBox = true
this.clickedCaseId = row.CASE_ID
this.sender = row.NAME
this.general = row.GENERAL
this.patName = row.PAT_NAME
if (row.CASE_STATE === this.$vue.getData('STATE_1FC_1GC') || row.CASE_STATE === this.$vue.getData('STATE_2RC_1GC') || row.CASE_STATE === this.$vue.getData('STATE_3GG')) {
this.btnValue = '开始会诊'
this.cannotClickBtn = false
} else {
this.btnValue = '会诊已结束'
this.cannotClickBtn = true
}
this.markAsRead(row)
},

startDiagnose () {

let params = new Map()
params.set('searchCaseType', ['1', '2'])
params.set('patHology', this.clickedCaseId)
this.$router.push({name: 'DzdCaseList', params: {searchCondition: params}})
},

async markDelById (row) {
let params = new URLSearchParams()
params.append('id', row.ID)
let index = this.displayList.indexOf(row.ID)
if (index !== -1) {

let suc = await this.$http.post(this.$vue.getData('MARK_DEL_BY_ID'), params)
if (suc.data.result === '1') {

let index = this.displayList.indexOf(row.ID)
this.displayList.splice(index, 1)
}
}

event.stopPropagation()
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/messageCenter/messageCenter.vue